"use client";

import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useEffect, Suspense } from "react";

function SignInContent() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get("callbackUrl") || "/";

  useEffect(() => {
    // Automatically trigger Google sign-in
    signIn("google", { callbackUrl });
  }, [callbackUrl]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
      <div className="text-center">
        {/* KreaytAI Logo - Style 27D */}
        <div className="mb-8">
          <span className="text-2xl font-medium tracking-[0.3em] uppercase">
            <span className="text-gray-300">K R E A Y T</span>
            <span className="text-purple-400 font-semibold ml-3">A I</span>
          </span>
        </div>
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-400 mx-auto mb-4"></div>
        <p className="text-lg text-gray-300">Redirecting to Google authentication...</p>
      </div>
    </div>
  );
}

export default function SignIn() {
  return (
    <Suspense fallback={
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-gray-900">
        <div className="text-center">
          {/* KreaytAI Logo - Style 27D */}
          <div className="mb-8">
            <span className="text-2xl font-medium tracking-[0.3em] uppercase">
              <span className="text-gray-300">K R E A Y T</span>
              <span className="text-purple-400 font-semibold ml-3">A I</span>
            </span>
          </div>
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-400 mx-auto mb-4"></div>
          <p className="text-lg text-gray-300">Loading...</p>
        </div>
      </div>
    }>
      <SignInContent />
    </Suspense>
  );
}